import { type WorkflowNodeType } from '@blaze-shared/api-contracts-domain';

import { type RuntimeEvent } from './event';

export interface RuntimeError {
  event?: RuntimeEvent;
  errorMessage: string;
  nodeId?: string;
  ns?: string;
  origin?: WorkflowNodeType | string;
  workflowId: string;
}

export enum RuntimeErrorMessage {
  DatasetOperationError = 'Dataset operation error',
  InsufficientInputData = 'Insufficient input data', // ie. empty array
  InvalidExpression = 'Invalid expression',
  InvalidInputData = 'Invalid input data',
  InvalidInputName = 'Invalid input name',
  InvalidWorkflow = 'Invalid or missing workflow',
  InvalidWorkflowNode = 'Invalid workflow node',
  InvalidWorkflowNodeType = 'Invalid workflow node type',
  MissingInputData = 'Missing input data',
  MissingRowInfo = 'Missing row information',
  MissingSchemaInfo = 'Missing schema information',
  NodeTargetsItself = 'Node targets itself',
  UnsupportedFrontendNode = 'Node "{{NODE_NAME}}" must be executed on the server',
  VariableExistsInDifferentScope = 'Variable "{{VAR_NAME}}" already exists in the "{{VAR_SCOPE}}" scope',
}
